import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import AppNavbar from "./components/AppNavbar";
import Hero from "./components/Hero";
import Vision from "./components/Vison";
import Mission from "./components/Mission";
import ServicesSection from "./components/ServicesSection";
import ProjectsSection from "./components/ProjectsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { useNavigate, useLocation } from "react-router-dom";
import ImageSlider from "./components/SliderImg";


import RFQCreate from "./pages/RFQCreate";
import About from "./pages/About";
import ContactlessWaterDispenser from "./products/ContactlessWaterDispenser";
import SmartEnergyMonitoringSystem from "./products/SmartEnergyMonitoringSystem";
import SmartFacilityMonitoringSystem from "./products/SmartFacilityMonitoringSystem";
import SmartDustbinMonitoringSystem from "./products/SmartDustbinMonitoringSystem";
import IndoorAirQualityMonitoringSystem from "./products/IndoorAirQualityMonitoringSystem";
import OccupancyCountingSystem from "./products/OccupancyCountingSystem";
import Clients from "./components/Clients";
import useScrollAnimation from "./hooks/useScrollAnimation";

function Home({ scrollToSection }) {
  const navigate = useNavigate();
  const location = useLocation();
  const visionRef = useScrollAnimation();
  const missionRef = useScrollAnimation();
  const clientsRef = useScrollAnimation();
  const servicesRef = useScrollAnimation();
  const projectsRef = useScrollAnimation();
  const contactRef = useScrollAnimation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        const yOffset = -72;
        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [location]);
  return (
    <div className="App">
      <div className="main-content">
        <Hero scrollToSection={scrollToSection} navigate={navigate} location={location} />
        <div ref={visionRef}><Vision /></div>
        <div ref={missionRef}><Mission /></div>
        <div ref={clientsRef}><Clients /></div>
        <div ref={servicesRef}><ServicesSection /></div>
        <div ref={projectsRef}><ProjectsSection /></div>
        <div ref={contactRef}><ContactSection /></div>
      </div>
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AppNavbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/rfq" element={<RFQCreate />} />
        <Route path="/about" element={<About />} />
        <Route path="/products/contactless-water-dispenser" element={<ContactlessWaterDispenser />} />
        <Route path="/products/smart-energy-monitoring-system" element={<SmartEnergyMonitoringSystem />} />
        <Route path="/products/smart-facility-monitoring-system" element={<SmartFacilityMonitoringSystem />} />
        <Route path="/products/smart-dustbin-monitoring-system" element={<SmartDustbinMonitoringSystem />} />
        <Route path="/products/indoor-air-quality-monitoring-system" element={<IndoorAirQualityMonitoringSystem />} />
        <Route path="/products/occupancy-counting-system" element={<OccupancyCountingSystem />} />

      </Routes>
    </Router>
  );
}
